KMVP.merchantBackofficeOrderDetails = {

    preparePage: function () {
        var _this = this;
        $('.js-refresh-order-status').ajaxForm({
            beforeSend: function () {
                _this.closePopups();
                $('.js-spinner-overlay').show();
            },
            success: function (data) {
                if(data) {
                    $('.js-spinner-overlay').hide();
                    $('#globalMessages').html(data);
                } else {
                    _this.waitForStatusChange(function () {
                        setTimeout(function () {window.location.reload();}, 1000);
                    });
                }
            },
            error: function () {
                window.location.reload();
            }
        });

        $('.js-upload-invoice-submit').click(function(e) {
            e.preventDefault();

            var fileList = $('.js-upload-invoice-input').prop("files");
            var file = fileList[0];
            var order = $('.js-order-data-input').val();

            var formData = new FormData();
            formData.append("invoice", file);
            formData.append("orderCode", order);

            var url = $(".js-upload-invoiceform").attr('action');

            $.ajax({
                type: 'POST',
                url: url,
                processData: false,
                contentType: false,
                data: formData,
                success: function () {
                    _this.closePopups();
                    window.location.reload();

                }
            })
        });
    },

    initPageEvents: function () {
        var _this = this;

        $('.js-order-reject-button').on("click", function (e) {
            e.preventDefault();
            e.stopPropagation()
            _this.closePopups();
            $('.js-order-reject').removeClass('hide');
            $('.js-no-reject-order-comment').addClass('hide');
        });

        $('.js-order-accept-button').on("click", function (e) {
            e.preventDefault();
            e.stopPropagation()
            _this.closePopups();
            $('.js-order-payment').removeClass('hide');
        });

        $('.js-order-upload-invoice-button').on("click", function (e) {
            e.preventDefault();
            e.stopPropagation()
            _this.closePopups();
            $('.js-order-upload-invoice').removeClass('hide');
        });

        $('.js-change-invoice').on("click", function (e) {
            e.preventDefault();
            e.stopPropagation()
            _this.closePopups();
            $('.js-order-upload-invoice').removeClass('hide');
        });

        $('.js-order-shipped-button').on("click", function (e) {
            e.preventDefault();
            e.stopPropagation()
            _this.closePopups();
            $('.js-order-set-delivery-date').removeClass('hide');

        });

        $('.js-cancel-popup').on("click", function (e) {
            e.preventDefault();
            _this.closePopups();
        });

        $('.reject-order-form-button').click(function(e) {
            e.preventDefault();

            if (!$.trim($('.reject-form .js-reject-order-comment').val())) {
                $('.js-no-reject-order-comment').removeClass('hide')
            } else {
                $('.reject-form').trigger("submit");
            }
        });

        $('.reject-form .js-reject-order-comment').on('focus', function(e) {
            $('.js-no-reject-order-comment').addClass('hide')
        });

        // click beside opened popup close all popups related with merchant order workflow
        $('.page-merchantBackofficeOrderDetailsPage #page').on("click", function (e) {
            if (!($(e.target).closest('.js-popup').length > 0)) {
                _this.closePopups();
            }
        });
    },

    closePopups: function () {
        $('.js-popup').addClass('hide');
    },

    /**
     * @param callback
     */
    waitForStatusChange: function (callback) {

        var $orderProcessing = $('.js-order-processing'),
            orderStatus = $('.input-order-status').val(),
            url = $orderProcessing.data('order-status-url'),
            maxCount = 5,
            count = 0;

        function askForStatus() {
            count++;
            $.ajax({
                url: url,
                success: function (data) {
                    if (data && orderStatus === data.status.code && count <= maxCount) {
                        // status is still equal, so ask again
                        setTimeout(function () {
                            askForStatus();
                        }, 2000)
                    } else {
                        // status has changed or timout, call callback function
                        if (callback) {
                            callback();
                        }
                    }
                }
            });
        }

        askForStatus();
    }

};

$(document).ready(function () {
    if ($(".page-merchantBackofficeOrderDetailsPage").length) {
        with (KMVP.merchantBackofficeOrderDetails) {
            preparePage();
            initPageEvents();
        }
    }
})